export default __webpack_public_path__ + "static/media/planeAsset 2.abc67121.svg";